
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'HiPay',

  data() {
    return {
      active: false,
      ip: null,
      hipay: null,
      config: {
        selector: 'hipay-hostedfields-form',
        template: 'auto',
        styles: {
          base: {
            fontSize: '16px',
          },
        },
      },
      cardInstance: null,
    };
  },

  computed: {
    ...mapState(['orderId', 'patientId', 'method', 'marketing']),
  },

  watch: {
    method(value) {
      this.active = value === 'card';
    },
    active(value) {
      if (value) {
        this.setMethod('card');
      } else if (this.method === 'card') {
        this.setMethod('null');
      }
    },
  },

  mounted() {
    this.getIp();
    this.hipay = window.HiPay({
      username: process.env.HIPAY_PRO_USER,
      password: process.env.HIPAY_PRO_PASSWORD,
      environment:
        process.env.HIPAY_PRO_STAGE && process.env.HIPAY_PRO_STAGE === 'true'
          ? 'stage'
          : 'production',
      lang: process.env.LANG,
    });
    this.cardInstance = this.hipay.create('card', this.config);
  },

  methods: {
    ...mapMutations(['setMethod']),

    getIp() {
      fetch('https://ifconfig.me/all.json')
        .then((response) => response.json())
        .then((res) => {
          this.ip = res.ip_addr;
        });
    },

    async pay() {
      this.$bolev.metaEvent({
        type: 'paymentInitiated',
        patientId: this.patientId,
      });
      try {
        const paymentData = await this.cardInstance.getPaymentData();
        paymentData.browser_info.http_accept = '*/*';
        paymentData.browser_info.ipaddr = this.ip;
        const { data } = await this.$bolev.hiPay({
          orderId: this.orderId,
          patientId: this.patientId,
          marketing: this.marketing,
          data: paymentData,
        });
        switch (data.state) {
          case 'pending':
          case 'completed':
            this.$emit('success', { method: 'card', state: data.state });
            break;
          case 'forwarding':
            window.location.href = data.url;
            break;
          case 'declined':
          case 'error':
          case 'unknown':
          default:
            this.$emit('fail', data);
            break;
        }
      } catch (e) {
        if (e.length && e[0]) {
          this.$emit('fail', e[0].error);
        } else {
          console.log(e);
        }
      }
    },
  },
};
